/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */

import {IEventLogger} from "../logging/event-logger.interface";
import {EventDatabaseLogger} from "../logging/event-database-logger";
import {IEvent} from "sirius-platform-support-library/shared/event-bus/event.interface";

(function () {
    const logger: IEventLogger = new EventDatabaseLogger(self);
    const queue = [];

    self.onmessage = async (message) => {
        const event = message.data as IEvent<any>;
        if (!event) {
            return;
        }
        queue.push(event);
    };

    setInterval(() => {
        const event = queue.shift() as IEvent<any>;
        if (!event) {
            return;
        }
        logger.log(event).catch((e) => {
            // Suppress error, we do not want it in console.
            // console.debug(`EventBusWebWorker: Encountered an exception while processing event ${event.type}/${event.id}`, e);
        });
    }, 10);
})();
